import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cbt-modal';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { deleteItemSourceConfigurationsForMenu } from 'apis/product-information-service/api';
import { APIErrorNotification, WoltModal } from 'common/components';
import { Typography as T } from 'common/typography';

type Props = {
  menuId: string;
  onClose: (shouldReloadMenu: boolean) => void;
};

const StyledWoltModal = styled(WoltModal)`
  background-color: ${cbSemanticCssVars.surfaceMain};
  border-radius: 8px;
  width: 100%;
  max-width: 480px;
`;

const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const StyledErrorNotification = styled(APIErrorNotification)`
  margin-block-end: 16px;
`;

const DisconnectFromCatalogModal = ({ menuId, onClose }: Props) => {
  const { mutate, error, isLoading } = useMutation(() => deleteItemSourceConfigurationsForMenu(menuId), {
    onSuccess: () => onClose(true),
  });
  return (
    <StyledWoltModal isOpen onRequestClose={() => (isLoading ? undefined : onClose(false))}>
      <ModalHeader onCloseClick={() => (isLoading ? undefined : onClose(false))}>
        <FormattedMessage id="menu.catalog.disconnect-items-title" />
      </ModalHeader>
      <ModalContent>
        <T.Body3>
          <FormattedMessage id="menu.catalog.disconnect-items-body" />
        </T.Body3>
      </ModalContent>
      <StyledModalFooter>
        {!!error && <StyledErrorNotification error={error} />}
        <Actions>
          <Button variant="secondary" size="small" onClick={() => onClose(false)} disabled={isLoading}>
            <FormattedMessage id="state.cancel" />
          </Button>
          <Button
            style={{ marginInlineStart: 16 }}
            variant="secondaryNegative"
            size="small"
            disabled={isLoading}
            loading={isLoading}
            onClick={() => mutate()}
          >
            <FormattedMessage id="menu.catalog.disconnect-button" />
          </Button>
        </Actions>
      </StyledModalFooter>
    </StyledWoltModal>
  );
};

export default DisconnectFromCatalogModal;
